/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payout_StatusInputs */

const en_payout_status = /** @type {(inputs: Payout_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payout Status`)
};

const es_payout_status = /** @type {(inputs: Payout_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado de pago`)
};

const fr_payout_status = /** @type {(inputs: Payout_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut du paiement`)
};

const de_payout_status = /** @type {(inputs: Payout_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auszahlungsstatus`)
};

const ja_payout_status = /** @type {(inputs: Payout_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支払いステータス`)
};

const zh_payout_status = /** @type {(inputs: Payout_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提现状态`)
};

const ar_payout_status = /** @type {(inputs: Payout_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حالة السحب`)
};

const id_payout_status = /** @type {(inputs: Payout_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status Pembayaran`)
};

const it_payout_status = /** @type {(inputs: Payout_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stato dei Pagamenti`)
};

const ru_payout_status = /** @type {(inputs: Payout_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус выплаты`)
};

const pt_payout_status = /** @type {(inputs: Payout_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status do Pagamento`)
};

const ko_payout_status = /** @type {(inputs: Payout_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정산 상태`)
};

/**
* | output |
* | --- |
* | "Payout Status" |
*
* @param {Payout_StatusInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const payout_status = /** @type {((inputs?: Payout_StatusInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payout_StatusInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_payout_status(inputs)
	if (locale === "es") return es_payout_status(inputs)
	if (locale === "fr") return fr_payout_status(inputs)
	if (locale === "de") return de_payout_status(inputs)
	if (locale === "ja") return ja_payout_status(inputs)
	if (locale === "zh") return zh_payout_status(inputs)
	if (locale === "ar") return ar_payout_status(inputs)
	if (locale === "id") return id_payout_status(inputs)
	if (locale === "it") return it_payout_status(inputs)
	if (locale === "ru") return ru_payout_status(inputs)
	if (locale === "pt") return pt_payout_status(inputs)
	return ko_payout_status(inputs)
});